import { ReactNode } from "react";
import { cva } from "class-variance-authority";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

type ColourType = "purple" | "mint" | "orange";

const ColouredContainer = ({
  header,
  children,
  footer,
  className,
  variant,
}: {
  header: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  variant?: ColourType;
}) => {
  const borderVariants = cva<{ variant: Record<ColourType, string[]> }>(
    "tw-border tw-border-solid tw-rounded-md tw-flex tw-flex-col",
    {
      variants: {
        variant: {
          purple: ["tw-border-primary"],
          mint: ["tw-border-mint-500"],
          orange: ["tw-border-orange"],
        },
      },
      defaultVariants: {
        variant: "purple",
      },
    },
  );

  const backgroundVariants = cva<{ variant: Record<ColourType, string[]> }>(
    "",
    {
      variants: {
        variant: {
          purple: ["tw-bg-purple-150"],
          mint: ["tw-bg-mint-100"],
          orange: ["tw-bg-orange-100"],
        },
      },
      defaultVariants: {
        variant: "purple",
      },
    },
  );

  return (
    <div className={twMerge(className, borderVariants({ variant }))}>
      <div
        className={twMerge(backgroundVariants({ variant }), "tw-rounded-t-md")}
      >
        {header}
      </div>

      <div className="tw-bg-white tw-rounded-b-md">{children}</div>

      {footer && (
        <div
          className={twMerge(
            backgroundVariants({ variant }),
            "tw-rounded-b-md tw-py-0 tw-my-0",
          )}
        >
          {footer}
        </div>
      )}
    </div>
  );
};
export default ColouredContainer;
